import { gettext } from '@eventbrite/i18n';

export const CURATED_CATEGORY_TAG_MAP = {
    'meeting-new-people': {
        text: gettext('Meeting new people').toString(),
        emoji: '👋',
    },
    'looking-to-try-new-things': {
        text: gettext('Looking to try new things').toString(),
        emoji: '🥁',
    },
    'being-part-of-a-community': {
        text: gettext('Being part of a community').toString(),
        emoji: '👨‍👩‍👧‍👦',
    },
    'looking-for-professional-networking': {
        text: gettext('Looking for professional networking').toString(),
        emoji: '👔',
    },
    'relaxing-and-unwinding': {
        text: gettext('Relaxing and unwinding').toString(),
        emoji: '🧘',
    },
    'learning-something-new': {
        text: gettext('Learning something new').toString(),
        emoji: '📚',
    },
    entertaining: {
        text: gettext('Entertaining').toString(),
        emoji: '🎭',
    },
    individuals: {
        text: gettext('Individuals').toString(),
        emoji: '👤',
    },
    'family-with-babies': {
        text: gettext('Families with babies').toString(),
        emoji: '👶',
    },
    'family-with-kids-up-to-5-years': {
        text: gettext('Families with kids up to 5 years').toString(),
        emoji: '👦',
    },
    'family-with-kids-from-6-to-10-years': {
        text: gettext('Families with kids from 6 to 10 years').toString(),
        emoji: '👧',
    },
    'family-with-kids-older-than-10-years': {
        text: gettext('Families with kids older than 10 years').toString(),
        emoji: '👨‍👩‍👧',
    },
    'friend-groups': {
        text: gettext('Friend groups').toString(),
        emoji: '👭',
    },
    'romantic-couples': {
        text: gettext('Romantic couples').toString(),
        emoji: '🧡',
    },
    'professional-environment': {
        text: gettext('Professional environment').toString(),
        emoji: '💼',
    },

    'dog-lovers': {
        text: gettext('Dog lovers').toString(),
        emoji: '🐶',
    },
};
